<a class="link {class} {linkClass} {buttonClass}" href={joinUrl(baseUrl, to)} on:click='goto(joinUrl(baseUrl, to), event)'>
    <slot></slot>
</a>

<style>

</style>

<script>
    const isActive = (pathname, to, exact) => {        
        if (exact) {
            if (pathname === to) return true
        } else {
            if (pathname.startsWith(to)) return true
        }

        return false
    }

    export default {
        computed: {
            buttonClass: ({ button }) => {
                return button ? 'button' : ''
            },
            linkClass: ({ isActive, activeClass }) => {
                const history = window.customHistory
                let classes = []
                
                if (isActive) classes.push(activeClass)

                return classes.filter(Boolean).join(' ')
            }
        },
        methods: {
            goto(to, event) {
                event.preventDefault()

                window.customHistory.push(to)

                window.scrollTo(0, 0)
            }
        },
        helpers: {
            joinUrl: (baseUrl, url) => {
                return '/' + [...baseUrl.split('/'), ...url.split('/')].filter(Boolean).join('/')
            }
        },
        oncreate() {
            // update state on location change
            const history = window.customHistory
            const component = this
            const { to, exact } = this.get()
            
            history.listen((location) => {
                component.set({
                    isActive: isActive(location.pathname, to, exact)
                })
            })

            component.set({
                isActive: isActive(history.location.pathname, to, exact)
            })         
		},
        data() {
            return {
                button: false,
                class: '',
                to: '/',
                baseUrl: '/',
                activeClass: '',
                exact: false,
                isActive: false
            }
        }
    }
</script>